import React, { useEffect } from "react";

function Navigation() {
  useEffect(() => {
    function loadScript(src) {
      console.log({src})
      return new Promise(function (resolve, reject) {
        var script = document.createElement("script");
        script.src = src;
        script.addEventListener("load", function () {
          resolve();
        });
        script.addEventListener("error", function (e) {
          console.log({ e });
          reject(e);
        });
        document.body.appendChild(script);
        document.body.removeChild(script);
      });
    }

    loadScript("/assets/js/mobilenav.js");
  }, []);

  return (
    <>
      <ul className="nav navbar-nav">
        <li className="active">
          <a href={"/"}>Accueil</a>
        </li>
        <li>
          <a>A Propos</a>
          <ul className="sub-menu">
            <li>
              <a href={"/about-1"}>Qui sommes-nous</a>
            </li>
            <li>
              <a>Mot du president</a>
            </li>
            <li>
              <a href={"/organisations"}>Organisations</a>
            </li>
          </ul>
        </li>
        <li>
          <a href={"/projets"}>Nos Projets</a>
        </li>
        <li>
          <a href={"/nous-rejoindre"}>Nous Rejoindre</a>
        </li>
        <li>
          <a href={"/annonces"}>Actualités</a>
        </li>
        <li>
          <a href={"/contact-us"}>Contact</a>
        </li>
      </ul>
    </>
  );
}

export default Navigation;
